module.exports = __webpack_public_path__ + "static/media/eyeball_icon.d3accb83.svg";